import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";
import Layout from "./components/Layout";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import SongsPage from "./pages/SongsPage";
import SongDetailPage from "./pages/SongDetailPage";
import MedleysPage from "./pages/MedleysPage";
import GeneratorPage from "./pages/GeneratorPage";
import SingerViewPage from "./pages/SingerViewPage";
import CommunityPage from "./pages/CommunityPage";
import FavoritesPage from "./pages/FavoritesPage";
import SettingsPage from "./pages/SettingsPage";

// Router component that handles auth callback detection
const AppRouter = () => {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback) - synchronously before routes
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      
      {/* Singer View - Special route (no sidebar) */}
      <Route 
        path="/singer" 
        element={
          <ProtectedRoute>
            <SingerViewPage />
          </ProtectedRoute>
        } 
      />
      
      {/* Protected routes with Layout */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Layout>
              <DashboardPage />
            </Layout>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/songs" 
        element={
          <ProtectedRoute>
            <Layout>
              <SongsPage />
            </Layout>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/songs/:songId" 
        element={
          <ProtectedRoute>
            <Layout>
              <SongDetailPage />
            </Layout>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/medleys" 
        element={
          <ProtectedRoute>
            <Layout>
              <MedleysPage />
            </Layout>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/medleys/:medleyId" 
        element={
          <ProtectedRoute>
            <Layout>
              <MedleysPage />
            </Layout>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/generator" 
        element={
          <ProtectedRoute>
            <Layout>
              <GeneratorPage />
            </Layout>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/community" 
        element={
          <ProtectedRoute>
            <Layout>
              <CommunityPage />
            </Layout>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/favorites" 
        element={
          <ProtectedRoute>
            <Layout>
              <FavoritesPage />
            </Layout>
          </ProtectedRoute>
        } 
      />
      
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Layout>
              <SettingsPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Default redirect */}
      <Route path="/" element={<LoginPage />} />
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster 
            position="top-right" 
            richColors 
            closeButton
            toastOptions={{
              className: 'font-body',
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
